import { createContext } from 'react';

import { Environment } from '../api/types';
import { Cart, Translations, Bundle, UiCategoryExt, UiBanner } from '../types';

export type AppContextType = {
    multilanguage: boolean;
    availableLanguages: {
        locale: string;
        selected: boolean;
        displayLanguage: string;
    }[];
    helpLink: string;
    translations: Translations;
    showSearch: boolean;
    showCart: boolean;
    showCategories: boolean;
    isArtificialCategoriesEnabled: boolean;
    categories: UiCategoryExt[];
    bonuspointsAvailable: boolean;
    mediaServerV2URL: string;
    deployStage: Environment;
    bundle: Bundle;
    brand: string;
    domain: string;
    translationsLocale: string;
    hoppsSuggestionsUrl: string;
    vendorAssetsURL: string;
    cart: Cart;
    securityIconsHTML: string | null;
    locale: string;
    selectedShopLanguage?: string;
    isNextJS: boolean;
    siteId: number;
    originalHost: string;
    isLoggedIn: boolean;
    customerId: number;
    customerStatusLoaded: boolean;
    isError: boolean;
    searchFlyoutSponsoredTagEnabled: boolean;
    shippingInfoLink: string;
    zooClubComponentEnabled: boolean;
    uiBitiba20AnniversaryLogoEnabled: boolean;
    banner: UiBanner;
};

export const defaultContext: AppContextType = {
    multilanguage: false,
    availableLanguages: [],
    bonuspointsAvailable: true,
    helpLink: '',
    translations: new Map(),
    showSearch: true,
    showCategories: true,
    isArtificialCategoriesEnabled: false,
    categories: [],
    showCart: true,
    bundle: 'zooplus',
    brand: 'zooplus',
    mediaServerV2URL: '',
    deployStage: 'dev',
    cart: { summary: { articleCount: 0 } },
    securityIconsHTML: null,
    locale: 'de-DE',
    domain: '',
    translationsLocale: '',
    hoppsSuggestionsUrl: '',
    vendorAssetsURL: '',
    isNextJS: false,
    siteId: -1,
    originalHost: '',
    isLoggedIn: false,
    customerStatusLoaded: false,
    customerId: -1,
    isError: false,
    searchFlyoutSponsoredTagEnabled: false,
    shippingInfoLink: '',
    zooClubComponentEnabled: false,
    uiBitiba20AnniversaryLogoEnabled: false,
    banner: { dog: null, cat: null, specials: null, root: null },
};

const AppContext = createContext(defaultContext);

export default AppContext;
